"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/esnext.json.parse.js");
var _tslib = require("tslib");
require("echarts/theme/macarons.js");
var _vuePropertyDecorator = require("vue-property-decorator");
var _PanelGroup = _interopRequireDefault(require("./components/PanelGroup.vue"));
var _LeadBarChart = _interopRequireDefault(require("./components/LeadBarChart.vue"));
var _GaugeRingChart = _interopRequireDefault(require("./components/GaugeRingChart.vue"));
var _TasksFunnelChart = _interopRequireDefault(require("./components/TasksFunnelChart.vue"));
var _SourcePieChart = _interopRequireDefault(require("./components/SourcePieChart.vue"));
var _TasksEvent = _interopRequireDefault(require("./components/TasksEvent.vue"));
var _InquiryValue = _interopRequireDefault(require("./components/InquiryValue.vue"));
var _FollowUpAndTaskTable = _interopRequireDefault(require("./components/FollowUpAndTaskTable.vue"));
var _LeadsTable = _interopRequireDefault(require("./components/LeadsTable.vue"));
var _CustomerReviewTable = _interopRequireDefault(require("./components/CustomerReviewTable.vue"));
var _EmployeePerformanceSankey = _interopRequireDefault(require("./components/EmployeePerformanceSankey.vue"));
var _LeaderboardTable = _interopRequireDefault(require("./components/LeaderboardTable.vue"));
var _MonthlyLeaderboardTable = _interopRequireDefault(require("./components/MonthlyLeaderboardTable.vue"));
var _admin = require("@/store/modules/admin");
var _admins = require("@/api/admins");
var _utils = require("@/utils");
// Theme used in BarChart, LineChart, PieChart and RadarChart

let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.dateRange = {};
    this.date = '';
    this.loggedInAdmin = null;
    this.isDatePanelVisible = true;
    this.adminsList = [];
    this.selectedAdminId = null;
    this.isDispatcher = false;
    this.isSales = false;
    this.isComingSoon = false;
    this.LOCAL_STORAGE_KEY = 'dashboard_date_range';
    this.customShortcuts = [{
      key: 'thisWeek',
      label: 'This week',
      value: 'isoWeek'
    }, {
      key: 'lastWeek',
      label: 'Last week',
      value: '-isoWeek'
    }, {
      key: 'last7Days',
      label: 'Last 7 days',
      value: 7
    }, {
      key: 'last30Days',
      label: 'Last 30 days',
      value: 30
    }, {
      key: 'thisMonth',
      label: 'This month',
      value: 'month'
    }, {
      key: 'lastMonth',
      label: 'Last month',
      value: '-month'
    },
    // { key: 'thisYear', label: 'This year', value: 'year' },
    // { key: 'lastYear', label: 'Last year', value: '-year' },
    {
      key: 'thisYear',
      label: 'This year',
      value: () => {
        const currentYear = this.$moment().year();
        const start = this.$moment(`${currentYear}-04-01`, 'YYYY-MM-DD'); // April 1st
        const end = this.$moment(`${currentYear + 1}-03-31`, 'YYYY-MM-DD'); // March 31st
        return {
          start: start,
          end: end
        };
      }
    }, {
      key: 'lastYear',
      label: 'Last year',
      value: () => {
        const currentYear = this.$moment().year();
        const start = this.$moment(`${currentYear - 1}-04-01`, 'YYYY-MM-DD'); // April 1st
        const end = this.$moment(`${currentYear}-03-31`, 'YYYY-MM-DD'); // March 31st
        return {
          start: start,
          end: end
        };
      }
    }];
    this.options = [{
      value: 'Clients',
      label: 'Clients'
    }, {
      value: 'Products',
      label: 'Products'
    }, {
      value: 'Leads',
      label: 'Leads'
    }];
    this.searchType = '';
    this.keywords = '';
  }
  onDateRangeChange(newVal) {
    if (newVal && newVal.start && newVal.end) {
      localStorage.setItem(this.LOCAL_STORAGE_KEY, JSON.stringify(newVal));
    } else {
      // Optional: If the user clears the date picker, remove it from local storage
      localStorage.removeItem(this.LOCAL_STORAGE_KEY);
    }
  }
  initDateRange() {
    const savedDates = localStorage.getItem(this.LOCAL_STORAGE_KEY);
    if (savedDates) {
      try {
        // If dates exist in local storage, parse and set them
        this.dateRange = JSON.parse(savedDates);
        return;
      } catch (error) {
        console.error('Failed to parse date from local storage:', error);
        // If it fails, let it fall through to the default logic below
      }
    }
    // Default logic (current month) if nothing is in local storage
    const date = new Date();
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.dateRange = {
      start: firstDay.toISOString(),
      end: lastDay.toISOString()
    };
  }
  created() {
    this.loggedInAdmin = _admin.AdminModule;
    this.isDispatcher = _admin.AdminModule.roles.toString() === 'Dispatcher';
    this.isSales = _admin.AdminModule.roles.toString() === 'Sales Coordinator';
    this.showDateSelectorPanel();
    this.dateRange = {};
    const date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.dateRange.end = lastDay.toISOString();
    this.dateRange.start = firstDay.toISOString();
    this.initDateRange();
    if (!['Super Admin', 'System Admin', 'Admin', 'Dispatcher'].includes(_admin.AdminModule.roles.toString())) {
      // add id to these fields
      this.selectedAdminId = _admin.AdminModule.id;
    }
    this.getAdminList();
  }
  activated() {
    this.loggedInAdmin = _admin.AdminModule;
    this.showDateSelectorPanel();
    this.dateRange = {};
    const date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.dateRange.end = lastDay.toISOString();
    this.dateRange.start = firstDay.toISOString();
    this.initDateRange();
    if (!['Super Admin', 'System Admin', 'Admin', 'Dispatcher'].includes(_admin.AdminModule.roles.toString())) {
      // add id to these fields
      this.selectedAdminId = _admin.AdminModule.id;
    }
    this.getAdminList();
  }
  getFinancialYearDates(date, isLastYear) {
    const currentYear = this.$moment().year();
    const start = isLastYear ? this.$moment(`${currentYear - 1}-04-01`, 'YYYY-MM-DD') : this.$moment(`${currentYear}-04-01`, 'YYYY-MM-DD'); // April 1st
    const end = isLastYear ? this.$moment(`${currentYear}-03-31`, 'YYYY-MM-DD') : this.$moment(`${currentYear + 1}-03-31`, 'YYYY-MM-DD'); // March 31st
    return {
      start: start,
      end: end
    };
  }
  async showDateSelectorPanel() {
    const admin = await this.loggedInAdmin.GetAdminInfo();
    this.isDatePanelVisible = ['Super Admin', 'System Admin', 'Admin'].includes(admin.role);
  }
  async getAdminList() {
    this.adminsList = await (0, _admins.getAdmins)((0, _utils.getQuery)({
      enabled: true,
      sort: 'fullName,ASC',
      filter: {
        enabled: '$eq'
      }
    }));
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('dateRange', {
  deep: true
})], default_1.prototype, "onDateRangeChange", null);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'DashboardAdmin',
  components: {
    PanelGroup: _PanelGroup.default,
    LeadBarChart: _LeadBarChart.default,
    GaugeRingChart: _GaugeRingChart.default,
    TasksFunnelChart: _TasksFunnelChart.default,
    SourcePieChart: _SourcePieChart.default,
    // SampleStatsRadialBarChart,
    TasksEvent: _TasksEvent.default,
    InquiryValue: _InquiryValue.default,
    FollowUpAndTaskTable: _FollowUpAndTaskTable.default,
    LeadsTable: _LeadsTable.default,
    CustomerReviewTable: _CustomerReviewTable.default,
    EmployeePerformanceSankey: _EmployeePerformanceSankey.default,
    LeaderboardTable: _LeaderboardTable.default,
    MonthlyLeaderboardTable: _MonthlyLeaderboardTable.default
  }
})], default_1);
var _default = exports.default = default_1;